import { render, staticRenderFns } from "./TabNew.vue?vue&type=template&id=70f304a0&"
import script from "./TabNew.vue?vue&type=script&lang=js&"
export * from "./TabNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports